<template>
    <footer id="footer" class="footer" :class="[hide ? 'hide' : null]">
        <div class="f-footer-gotop" @click="$SmoothScroll(0,600);">
            <i class="fa fa-angle-up"></i>
        </div>
        <div class="container">


            <div class="columns">
                <div class="column">
                    <router-link tag="p" class="f-footerlogo has-text-centered-mobile" to="/" style="cursor:pointer;">
                        <img src="/static/images/layout/logowhitebottom.png" alt="">
                    </router-link>
                    <ul>
                        <li class="has-text-centered-mobile is-size-6-mobile"><a href="https://facebook.com/pt.facilimo" target="_blank"><img class="f-footersocial" src="/static/images/layout/facebookwhitebottom.png" alt=""> Facebook</a></li>
                        <li class="has-text-centered-mobile is-size-6-mobile"><a href="https://instagram.com/facilimo.pt" target="_blank"><img class="f-footersocial" src="/static/images/layout/instagramwhitebottom.png" alt=""> Instagram</a></li>
                    </ul>
                </div>
                <div class="column">
                    <h4 class="has-text-centered-mobile is-size-5-mobile"><b>FACILIMO</b></h4>
                    <ul>
                        <router-link tag="li" to="quemsomos" class="has-text-centered-mobile is-size-6-mobile footer-link">Quem somos</router-link>
                        <router-link tag="li" to="contacto" class="has-text-centered-mobile is-size-6-mobile footer-link">Contacto</router-link>
                        <router-link tag="li" to="registo" class="has-text-centered-mobile is-size-6-mobile footer-link">Registe-se</router-link>

                    </ul>
                </div>
                <div class="column">
                    <h4 class="has-text-centered-mobile is-size-5-mobile"><b>CLIENTES</b></h4>
                    <ul>
                        <router-link tag="li" to="comofunciona" class="has-text-centered-mobile is-size-6-mobile footer-link">Como funciona</router-link>

                    </ul>
                </div>
                <div class="column">
                    <h4 class="has-text-centered-mobile is-size-5-mobile"><b>PROFISSIONAIS</b></h4>
                    <ul>
                        <router-link tag="li" to="profissionais" class="has-text-centered-mobile is-size-6-mobile footer-link">Como funciona</router-link>
                        <router-link tag="li" to="pacotes" class="has-text-centered-mobile is-size-6-mobile footer-link">Pacotes</router-link>
                        <router-link tag="li" to="registo" class="has-text-centered-mobile is-size-6-mobile footer-link">Registo grátis</router-link>

                    </ul>
                </div>
                <div class="column">
                    <h4 class="has-text-centered-mobile is-size-5-mobile"><b>PRECISA DE AJUDA?</b></h4>
                    <ul>
                        <li class="has-text-centered-mobile is-size-6-mobile"><a href="mailto:suporte@facilimo.pt">Envie-nos um e-mail</a></li>
                        <li class="has-text-centered-mobile is-size-6-mobile"><a href="mailto:suporte@facilimo.pt"><i class="fa fa-envelope"></i><span style="font-size: 0.75rem;font-weight: 300;"> suporte@facilimo.pt</span></a></li>
                    </ul>
                </div>

            </div>

            <p class="f-footercopyright is-size-6-mobile" >©<b> FACILIMO</b> {{year}}. Todos os direitos reservados. <router-link to="termos">Termos de utilização</router-link> | <router-link to="privacidade">Política de privacidade</router-link></p>
        </div>
    </footer>
</template>

<script>
export default {
  data() {
    return {
      year: null,
      hide: this.$route.meta.hidefoot
    };
  },
  mounted() {
    let date = new Date();
    this.year = date.getFullYear();
  },

  watch: {
    "$route.name": function() {
      this.hide = this.$route.meta.hidefoot;
    }
  },

  methods: {
    goTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style scoped lang="scss">
.hide {
  display: none;
}

#footer {
  padding-top: 3rem;
  position: relative;
  //font-family: "Open Sans", sans-serif;
  font-family: "Roboto", sans-serif;
  color: white;
  border-top: solid 8px #e90054;
  z-index: 2;
}

.f-footer-gotop {
  position: absolute;
  width: 2.75rem;
  height: 2.75rem;
  color: white;
  background-color: #e90054;
  top: 3rem;
  left: 80vw;
  font-size: 1.5rem;
  text-align: center;
  margin-top: -3rem;
  line-height: 2.75rem;
  cursor: pointer;
}

h4 {
  text-align: left;
  color: white;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
}

ul {
  margin-left: 0;
}

li {
  list-style: none;
  text-align: left;
  font-size: 0.85rem;
}

.footer-link {
  list-style: none;
  text-align: left;
  font-size: 0.85rem;
  cursor: pointer;
}

li a img {
  height: 1.2rem;
}

li a {
  color: white;
}

li a :hover {
  color: white;
}

.column {
  margin: 0.5rem;
}

.footer {
  padding: 6rem 0 2rem;
}

.f-footerlogo {
  position: relative;
  //left: -1.5rem;
  //top: -0.5rem;
  height: 2.75rem;
}

.f-footerlogo img {
  height: 1.6rem;
  margin-bottom: 0.5rem;
}

.f-footersocial {
  margin-left: 1.5rem;
  vertical-align: middle;
}

.f-footercopyright {
  margin: 0.5rem;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 300;
  margin-top: 4rem;
}

@media only screen and (min-width: 769px) {
  .f-footer-gotop {
    left: 90vw;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1023px) {
  li {
    font-size: 0.9rem;
  }
}

@media only screen and (max-width: 768px) {
  .footer {
    padding: 2rem;
  }
  .f-footer-gotop {
    left: 80vw;
  }
}

a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue